import $ from 'jquery'

// Simulate the click on li children for social logins.
var socialLoginsButton = $('.js-the_champ_login_li');
socialLoginsButton.on( 'click', function() {
  if ( $.type( $(this) ) ) {
    $(this).children( 'i' ).click();
  }
} );
// Disable propagation when click is simulated.
$('.js-the_champ_login_li i').on( 'click', function( event ){
  event.stopPropagation();
} );

// Open dialog only when uncheck a newsletter's checkbox.
var newsLetterCheckox = $( '.js-newsletter-checkbox' );
newsLetterCheckox.on( 'click', function() {
  if ( ! $(this).is(':checked') ) {
    popupNewsletter.foundation('open');
  }
} );

var saveNewsletterButton = $( '.js-button-save-newsletters-account' );
var popupNewsletter = $('.js-newsletter-unsubscribe-reason-dialog');
saveNewsletterButton.on('click', function( e ){
  e.preventDefault();
  saveNewsletterButton.prop('disabled', true);

  var newsLetterToAdd = new Array;
  var newsLetterToRemove = new Array;
  var newsLetterCheckoxes = document.querySelectorAll( '.js-newsletter-checkbox' );
  for ( const newsLetter of newsLetterCheckoxes ) {
    if ( newsLetter.checked == true ) {
      newsLetterToAdd.push( newsLetter.value );
    } else {
      newsLetterToRemove.push( newsLetter.value );
    }
  }

  // Ajax Call
  var xhr = new XMLHttpRequest();
  var loadNewsAjaxUrl =
    'action=newsletter_subscription_save' +
    '&wp-nonce=' + e.currentTarget.getAttribute('data-nonce') +
    '&newsletter-to-add=' + newsLetterToAdd +
    '&newsletter-to-remove=' + newsLetterToRemove;
  xhr.open('POST', ecom_js.ajaxurl, true);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.onload = function() {
    if (xhr.status === 200) {
      var response = JSON.parse(xhr.response);
    }
    saveNewsletterButton.prop('disabled', false);
  };
  xhr.send(loadNewsAjaxUrl);
});
